import { CSSProperties } from "react";
import { colors } from "src/phone-cemetery-client-common/Util/colors";

export const rootView: CSSProperties = {
	backgroundColor: colors.primaryTransparent,
	flex: 1
}